import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from 'widgets/Button';

import msg from 'msg';

export default class ButtonWithFeedback extends PureComponent {
  static propTypes = {
    requestInProgress: PropTypes.bool,
    successLabel: PropTypes.string,
    wasRequestSuccessful: PropTypes.bool,
    forceShowSuccessMessage: PropTypes.bool, // show the end state on demand, used on styleguide
    children: PropTypes.node,
  };

  static defaultProps = {
    successLabel: msg.settings.buttons.saved,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const nextState = {};
    if (prevState.requestInProgress && !nextProps.requestInProgress && nextProps.wasRequestSuccessful) {
      nextState.showSuccessMessage = true;
    }
    nextState.requestInProgress = nextProps.requestInProgress;
    return nextState;
  }

  state = {
    showSuccessMessage: false,
    requestInProgress: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.requestInProgress === true && this.props.requestInProgress === false) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.setState({ showSuccessMessage: false }); }, 2000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const {
      requestInProgress,
      successLabel,
      children,
      wasRequestSuccessful,
      forceShowSuccessMessage,
      ...passProps
    } = this.props;

    const showSuccessMessage = forceShowSuccessMessage || this.state.showSuccessMessage;
    return (
      <Button
        disabled={requestInProgress}
        requestInProgress={requestInProgress}
        showSuccessMessage={showSuccessMessage}
        {...passProps}
      >
        {showSuccessMessage ? successLabel : children}
      </Button>
    );
  }
}
